"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProviderState = exports.createDDLDispatcher = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reducer = _interopRequireWildcard(require("./reducer"));

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var createDDLDispatcher = function createDDLDispatcher(dispatch) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref) {
    var name = _ref.name,
        value = _ref.value;
    return dispatch(_reducer.actionCreators.updateDDL({
      name: name,
      value: value,
      enableDiff: props.enableDiff
    }));
  };
};

exports.createDDLDispatcher = createDDLDispatcher;
var defaultProviderState = {
  subscribers: {},
  // list of functions subscribed to ddl updates
  history: [],
  // event history where length is equal to historyLimit
  historyLimit: 0,
  // number of events preserved in history
  ddl: {} // data layer

};
exports.defaultProviderState = defaultProviderState;
var DDLPureContext = /*#__PURE__*/(0, _react.memo)(function (_ref2) {
  var children = _ref2.children,
      ddlFunctions = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_context.default.Provider, {
    value: ddlFunctions
  }, children);
});
DDLPureContext.propTypes = {
  children: _propTypes.default.node.isRequired
};

var DDLProvider = /*#__PURE__*/function (_Component) {
  _inherits(DDLProvider, _Component);

  var _super = _createSuper(DDLProvider);

  function DDLProvider(props) {
    var _this;

    _classCallCheck(this, DDLProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getDDL", function () {
      return _this.state.ddl;
    });

    _defineProperty(_assertThisInitialized(_this), "dispatch", function (action) {
      _this.setState(function (state) {
        return (0, _reducer.default)(state, action);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "subscribe", function (_ref3) {
      var subscriber = _ref3.subscriber,
          handler = _ref3.handler;

      _this.dispatch(_reducer.actionCreators.addSubscriber({
        subscriber: subscriber,
        handler: handler
      }));

      return function () {
        return _this.dispatch(_reducer.actionCreators.removeSubscriber({
          subscriber: subscriber
        }));
      };
    });

    _this.state = _objectSpread(_objectSpread({}, defaultProviderState), props.initialDDL);
    _this.updateDDL = createDDLDispatcher(_this.dispatch, props);
    return _this;
  } // eslint-disable-next-line react/destructuring-assignment


  _createClass(DDLProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var getDDL = this.getDDL,
          updateDDL = this.updateDDL,
          subscribe = this.subscribe;
      return /*#__PURE__*/_react.default.createElement(DDLPureContext, {
        getDDL: getDDL,
        updateDDL: updateDDL,
        subscribe: subscribe
      }, children);
    }
  }]);

  return DDLProvider;
}(_react.Component);

DDLProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  initialDDL: _propTypes.default.shape({}),
  // eslint-disable-next-line react/no-unused-prop-types
  enableDiff: _propTypes.default.bool
};
DDLProvider.defaultProps = {
  initialDDL: undefined,
  enableDiff: false
};
var _default = DDLProvider;
exports.default = _default;